module.exports = __webpack_public_path__ + "static/media/pydetecting.25ac1f40.jpg";